export const getDropdown = (object) =>
  object.map((value) => {
    const { name, id } = value;
    return {
      id,
      value: id,
      label: name,
    };
  });
